import { useState } from 'react';
import client from '../api/client';

const TYPES = [
  { value: 'bug', label: 'Bug' },
  { value: 'feature', label: 'Feature Request' },
  { value: 'other', label: 'Other' },
];

export default function FeedbackButton() {
  const [open, setOpen] = useState(false);
  const [type, setType] = useState('bug');
  const [message, setMessage] = useState('');
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!message.trim()) return;
    setSending(true);
    try {
      await client.post('/auth/feedback/', {
        type,
        message,
        page_url: window.location.href,
      });
      setSent(true);
      setMessage('');
      setTimeout(() => { setSent(false); setOpen(false); }, 2000);
    } catch {
      alert('Failed to send. Please try again.');
    } finally {
      setSending(false);
    }
  };

  return (
    <>
      <button
        className="feedback-fab"
        onClick={() => setOpen(true)}
        title="Report a bug or suggestion"
      >
        ?
      </button>

      {open && (
        <div className="feedback-overlay" onClick={() => setOpen(false)}>
          <div className="feedback-modal" onClick={(e) => e.stopPropagation()}>
            <div className="feedback-header">
              <h3>Report an Issue</h3>
              <button className="feedback-close" onClick={() => setOpen(false)}>&times;</button>
            </div>

            {sent ? (
              <div className="feedback-sent">Thanks for your feedback!</div>
            ) : (
              <form onSubmit={handleSubmit}>
                <div className="feedback-types">
                  {TYPES.map((t) => (
                    <button
                      key={t.value}
                      type="button"
                      className={`feedback-type-btn ${type === t.value ? 'active' : ''}`}
                      onClick={() => setType(t.value)}
                    >
                      {t.label}
                    </button>
                  ))}
                </div>
                <textarea
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                  placeholder="Describe the issue or your suggestion..."
                  rows={4}
                  required
                  minLength={5}
                />
                <button type="submit" className="btn" disabled={sending} style={{ width: '100%' }}>
                  {sending ? 'Sending...' : 'Send'}
                </button>
              </form>
            )}
          </div>
        </div>
      )}
    </>
  );
}
